export const appStandortWidget = {
    create: function() {
        if (document.querySelector('.js-standort-widget-dd')) {
            this.bindEvents();
        }
    },
    bindEvents: function() {
        const handleExpand = (widget) => {
            widget.setAttribute('data-state', 'expanded');
            widget.querySelector('.js-standort-widget-toggle').setAttribute('aria-expanded', 'true');
            widget.querySelector('.js-standort-widget-menu').setAttribute('aria-hidden', 'false');
            widget.querySelectorAll('.js-sdd-option').forEach(option => {
                option.setAttribute('tabindex', '0');
            });
        };

        const handleCollapse = (widget) => {
            widget.setAttribute('data-state', 'closed');
            widget.querySelector('.js-standort-widget-toggle').setAttribute('aria-expanded', 'false');
            widget.querySelector('.js-standort-widget-menu').setAttribute('aria-hidden', 'true');
            widget.querySelectorAll('.js-sdd-option').forEach(option => {
                option.setAttribute('tabindex', '-1');
            });
        };

        const eventHandler = (event) => {
            const toggle = event.target.closest('.js-standort-widget-toggle');
            const widget = toggle ? toggle.closest('.js-standort-widget-dd') : null;
            
            if (toggle) {
                event.preventDefault();
                const isExpanded = widget.getAttribute('data-state') === 'expanded';
                if (isExpanded) {
                    handleCollapse(widget);
                } else {
                    handleExpand(widget);
                }
            } else {
                document.querySelectorAll('.js-standort-widget-dd[data-state="expanded"]').forEach(expandedWidget => {
                    handleCollapse(expandedWidget);
                });
            }
        };

        const escHandler = (event) => {
            if (event.key === 'Escape') {
                document.querySelectorAll('.js-standort-widget-dd[data-state="expanded"]').forEach(expandedWidget => {
                    handleCollapse(expandedWidget);
                });
            }
        };

        document.addEventListener('click', eventHandler);
        document.addEventListener('keydown', escHandler);
    }
};
